import { createStandardAction } from 'typesafe-actions';
import { ICtaFooter } from './types';

export const updateVisibleCtaFooter = createStandardAction(
  'ctaFooter/UPDATE_VISIBLE'
)<ICtaFooter | undefined>();
